import { Link } from "react-router-dom";
import styled from "styled-components";

export const SLink = styled(Link)`
    text-decoration: none;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
    /* padding-top: 30px; */
    width: 100%;
    color: black;
`